/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientRiskMatrixAssessRequestDto } from '../../models/client-risk-matrix-assess-request-dto';
import { ClientRiskMatrixAssessResponseDto } from '../../models/client-risk-matrix-assess-response-dto';

export interface Assess$Params {
      body: ClientRiskMatrixAssessRequestDto
}

export function assess(http: HttpClient, rootUrl: string, params: Assess$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientRiskMatrixAssessResponseDto>> {
  const rb = new RequestBuilder(rootUrl, assess.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientRiskMatrixAssessResponseDto>;
    })
  );
}

assess.PATH = '/kyc/client-risk-matrix/assess';
